/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {WhmcsClient, WhmcsClientDetails} from '../models/whmcs-client.model';
import {WhmcsStats} from '../models/whmcs-stats.model';

@Injectable({providedIn: 'root'})
export class WhmcsService {
	getWhmcsClients(status: number): Observable<WhmcsClient[]> {
		return this.http.post(
			API_ENDPOINTS.WHMCS.WHMCS_GET_CLIENTS,
			{
				status: status
			}
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toWhmcsClientArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	getWhmcsStats(): Observable<WhmcsStats> {
		return this.http.post(
			API_ENDPOINTS.WHMCS.WHMCS_GET_STATS,
			{}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return new WhmcsStats(
							response.message.income_today,
							response.message.income_thismonth,
							response.message.income_thisyear,
							response.message.networkissues_open,
							response.message.orders_pending,
							response.message.tickets_open,
							response.message.cancellations_pending,
							response.message.staff_online
						);
					} else {
						return response.message;
					}
				})
			);
	}

	syncWhmcsClients(): Observable<boolean | any> {
		return this.http.post(
			API_ENDPOINTS.WHMCS.WHMCS_SYNC_CLIENTS,
			{}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return true;
					} else {
						return false;
					}
				})
			);
	}

	getWhmcsClientDetails(clientId: number): Observable<WhmcsClientDetails> {
		return this.http.post(
			API_ENDPOINTS.WHMCS.WHMCS_GET_CLIENT_DETAILS,
			{
				clientId: clientId
			}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return new WhmcsClientDetails(
							response.message.phonecc,
							response.message.phonenumber,
							response.message.telephoneNumber,
							response.message.tax_id,
							response.message.notes,
							response.message.country
						);
					} else {
						return response.message;
					}
				})
			);
	}

	private toWhmcsClientArray(data): WhmcsClient[] {
		const clients: WhmcsClient[] = [];
		for (const item of data) {
			clients.push(
				new WhmcsClient(
					parseInt(item.id, 10),
					StringFunctions.emptyToNull(item.firstname),
					StringFunctions.emptyToNull(item.lastname),
					StringFunctions.emptyToNull(item.companyname),
					StringFunctions.emptyToNull(item.email),
					(parseInt(item.active, 10) === 1)
				)
			);
		}
		return clients;
	}

	constructor(private http: HttpClient) { }
}
